import React from 'react'
import classNames from 'classnames'

import './Progress.scss'

const VARIANT_PRIORITY = ['critical', 'warning', 'magical', 'success']

const pickVariant = (props) => VARIANT_PRIORITY.find((name) => Boolean(props[name])) || null

/**
 * @import import { Progress } from '@/components/progress/Progress'
 * @param {object} props
 * @param {number} [props.value] Fill percentage from 0 to 100
 * @param {boolean} [props.success] Success fill for completed or passing work
 * @param {boolean} [props.warning] Warning fill for at-risk work
 * @param {boolean} [props.critical] Critical fill for failing work
 * @param {boolean} [props.magical] Gradient fill for AI-driven work
 * @param {boolean} [props.indeterminate] Animated fill for work with no measurable fraction
 */
export function Progress({
  value,
  success,
  warning,
  critical,
  magical,
  indeterminate,
  className,
  ...rest
}) {
  // Defensive: undefined / NaN / strings all collapse to 0 rather than
  // producing `NaN%` widths or `aria-valuenow="NaN"`.
  const numeric = Number.isFinite(value) ? value : 0
  const clamped = Math.max(0, Math.min(100, numeric))
  const variant = pickVariant({ success, warning, critical, magical })

  return (
    <div
      className={classNames('progress', className, variant && { [variant]: true }, {
        indeterminate,
      })}
      role="progressbar"
      aria-valuenow={indeterminate ? undefined : clamped}
      aria-valuemin={0}
      aria-valuemax={100}
      {...rest}
    >
      <div className="progress-fill" style={{ '--progress-value': `${clamped}%` }} />
    </div>
  )
}
